import { Icon } from "@ui/Icon";
import askGVTLogoSmall from "@ui/icons/AskGVTLogoSmall.svg?raw";
import gvtStudioLogoSmall from "@ui/icons/GVTStudioLogoSmall.svg?raw";
import { useAppContext, useLayoutAppKind } from "@ui/layouts/layoutProvider";
import { Tooltip, TooltipTrigger } from "@ui/Tooltip";
import { createSignal } from "solid-js";
import "./PlatformSwitch.css";

type Product = "askgvt" | "studio";

/** Segmented Ask ↔ Studio control that sits above the sidebar's main CTA. */
export const PlatformSwitch = () => {
	const { menuIsOpen } = useAppContext();
	// Each option is a full page load, so the thumb moves on click to acknowledge the choice before the next page paints.
	const [selected, setSelected] = createSignal<Product>(
		useLayoutAppKind() === "studio" ? "studio" : "askgvt",
	);

	return (
		<div class="platform-switch" data-selected={selected()}>
			<span class="platform-switch__thumb" aria-hidden="true" />
			<SwitchOption
				href="/"
				mark={askGVTLogoSmall}
				label="Ask"
				name="AskGVT"
				selected={selected() === "askgvt"}
				tooltipDisabled={menuIsOpen()}
				onSelect={() => setSelected("askgvt")}
			/>
			<SwitchOption
				href="/studio"
				mark={gvtStudioLogoSmall}
				label="Studio"
				name="Creator studio"
				selected={selected() === "studio"}
				tooltipDisabled={menuIsOpen()}
				onSelect={() => setSelected("studio")}
			/>
		</div>
	);
};

const SwitchOption = (props: {
	href: string;
	mark: string;
	label: string;
	/** Full product name, used where the short label is hidden. */
	name: string;
	selected: boolean;
	tooltipDisabled: boolean;
	onSelect: () => void;
}) => (
	<TooltipTrigger
		placement="right"
		anchorTo=".side-bar"
		disabled={props.tooltipDisabled}
	>
		<a
			class="platform-switch__option"
			classList={{ "platform-switch__option--selected": props.selected }}
			href={props.href}
			aria-label={props.name}
			aria-current={props.selected ? "page" : undefined}
			onClick={() => props.onSelect()}
		>
			<Icon
				icon={props.mark}
				fillWithCurrentColor={false}
				class="platform-switch__mark"
				display="inline-flex"
			/>
			<span class="platform-switch__label">{props.label}</span>
		</a>
		<Tooltip>{props.name}</Tooltip>
	</TooltipTrigger>
);
